import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducer/rootReducer';
import logger from './middleware/logger';

const preloadedState = {};

const store = configureStore({
  reducer: rootReducer,
  preloadedState,
  // Redux DevTools работают в next dev и test; в production-сборке без test отключены.
  devTools: process.env.NODE_ENV === 'development' || process.env.TAMAGOTCHI_BUILD_TARGET === 'test',
  middleware: (getDefaultMiddleware) => {
    let middleware = getDefaultMiddleware({ serializableCheck: false });
    if (process.env.NODE_ENV === 'development') middleware = middleware.concat(logger);
    return middleware;
  },
});

export default store;
